export const exportPopulationActions = {
  // Population tally export
  populationDataTallyExportLoading: "POPULATION_DATA_TALLY_EXPORT_LOADING",
  populationDataTallyExportLoadReady: "POPULATION_DATA_TALLY_EXPORT_LOAD_READY"
};
